import { ACTIVITIES_ANSWER_MODE_FREE } from 'global/constants';
import { MultipleChoiceOption } from '../multiple-choice.constants';

export function isSingleSelect({
  answerMode,
  isFreeAnswerMultiSelect,
  options,
}: {
  answerMode: string | null;
  isFreeAnswerMultiSelect: boolean | null;
  options: MultipleChoiceOption[];
}) {
  if (answerMode === ACTIVITIES_ANSWER_MODE_FREE) {
    return (
      isFreeAnswerMultiSelect === null || isFreeAnswerMultiSelect === false
    );
  }
  return options.filter(o => o.correctAnswerBoolean).length === 1;
}
